module.exports = __webpack_public_path__ + "static/media/EU.abdc658b.jpg";